<div class="login-container">
  <div style="background-image: url('assets/images/login/boywithmob.png'),
    url('assets/images/login/girlwithkey.png');
    background-position: bottom left , bottom right;
    background-repeat: no-repeat,no-repeat;
    background-size: 350px , 310px;max-width: 1300px"
       class="login">
    <img style="cursor: pointer" [routerLink]="['/']" src="assets/images/newLogo.png">
    <h2 class="col-sm-12" style="margin-bottom: 24px;text-align: center">
      {{ "LOGIN.LOGIN_TO_ACCOUNT" | translate }}
    </h2>
    <form class="login-form row" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <div class="col-sm-12">
        <mat-form-field appearance="outline" class="w-100" color="primary">
          <mat-label>{{ "LOGIN.USERNAME" | translate }}</mat-label>
          <input matInput formControlName="userId"/>
        </mat-form-field>
      </div>
      <div class="col-sm-12">
        <mat-form-field appearance="outline" class="w-100" color="primary">
          <mat-label>{{ "LOGIN.PASSWORD" | translate }}</mat-label>
          <input matInput formControlName="password" [type]="showPasswordText ? 'password' : 'text'"/>
          <i class="material-icons" style="cursor: pointer" matSuffix (click)="showPasswordText = !showPasswordText">
            {{showPasswordText ? 'visibility' : 'visibility_off'}}
          </i>
        </mat-form-field>
      </div>

      <div class="d-flex align-items-center m-b-12">
        <button
          mat-button
          type="button"
          color="primary"
          (click)="openForgetPassDialog()"
          class="text-primary f-w-600 text-decoration-none m-l-auto f-s-14"
        >{{ "LOGIN.FORGET_PASSWORD" | translate }}</button
        >
      </div>

      <div style="width: 100%;">
        <button
          class="login-button"
          *ngIf="loginForm"
          [disabled]="!loginForm.valid"
          mat-raised-button
          type="submit"
          color="primary"
          style="width: 100%;"

        >
          <span>{{ "LOGIN.FORM_BUTTON" | translate }}</span>
        </button>
      </div>
      <span class="d-block f-w-500 text-center m-t-24"
      >{{ "LOGIN.NO_ACCOUNT" | translate }}
            <a
              [routerLink]="['../register']"
              class="text-decoration-none text-primary f-w-500 f-s-14">{{ "LOGIN.REGISTER_NOW" | translate }}</a>
          </span>

    </form>

    <div class="row options" style="justify-content: space-between">
      <button (click)="changeLanguage()" mat-mini-fab
              matTooltip="{{_translate.currentLang === 'ar' ? 'change language to english' : 'تغيير إلي اللغة العربية'}}"
              style="background-color: #6a259a;" aria-label="Example icon button with a home icon">
        <mat-icon>translate</mat-icon>
      </button>
      <button [routerLink]="['/index']" mat-mini-fab style="background-color: #6a259a;"
              matTooltip="{{_translate.currentLang === 'ar' ? 'الرئيسية' : 'Home'}}"
              aria-label="Example icon button with a home icon">
        <mat-icon>home</mat-icon>
      </button>
    </div>
  </div>
</div>





